'use strict';

require('./CompanyPublicationService.js');

function CompanyPublicationsFlowVerifiesCtrl(
  $scope,
  $translate,
  growl,
  publicationsFlowVerifies,
  CompanyPublicationService,
  $stateParams,
  $state
) {

  $scope.publicationsFlowVerifies = publicationsFlowVerifies;
  $scope.more = false;
  $scope.page = parseInt($stateParams.page, 10) || 1;
  
  if($scope.publicationsFlowVerifies.length === 21) {
    $scope.more = true;
    $scope.publicationsFlowVerifies.pop();
  }
  $scope.filter = {
    manager: null,
    status: null
  };

  if ($stateParams.manager) {
    $scope.filter.manager = $stateParams.manager;
  }

  if ($stateParams.status) {
    $scope.filter.status = $stateParams.status;
  }

  $scope.cancelVerify = function(publicationsFlowVerify){
    publicationsFlowVerify.status = 'CANCEL';
    CompanyPublicationService.updateFlowVerify({publicationId: publicationsFlowVerify.publication.id, publicationsVerifyId: publicationsFlowVerify.id}, publicationsFlowVerify).$promise.then(function(){
      growl.addSuccessMessage($translate.instant('flow.cancel-certify-flow-success'));
      $scope.publicationsFlowVerifies.splice($scope.publicationsFlowVerifies.indexOf(publicationsFlowVerify), 1);
    }, function(err) {
      if(err.status === 400){
        growl.addErrorMessage(err.data);
      }else{
        growl.addErrorMessage($translate.instant('flow.cancel-certify-flow-failure'));
      }
    });
  };

  $scope.searchNotices = function() {
    $state.go('root.company.publications-flowVerifies', {manager: $scope.filter.manager, status: $scope.filter.status, page: null});
  };
}

CompanyPublicationsFlowVerifiesCtrl.resolve = {
  publicationsFlowVerifies: ['$stateParams', 'CompanyPublicationService', function($stateParams, CompanyPublicationService) {
    var page      = parseInt($stateParams.page, 10) || 1;
    var filter    = {
      companyId: $stateParams.companyId,
      manager: $stateParams.manager || null,
      status: $stateParams.status || null,
      limit:     21,
      offset:    (page - 1) * 20
    };

    return CompanyPublicationService.queryFlowVerifies(filter).$promise;
  }]
};

module.exports = CompanyPublicationsFlowVerifiesCtrl;

angular.module('dokiv')
  .controller('CompanyPublicationsFlowVerifiesCtrl', [
    '$scope',
    '$translate',
    'growl',
    'publicationsFlowVerifies',
    'CompanyPublicationService',
    '$stateParams',
    '$state',
    CompanyPublicationsFlowVerifiesCtrl
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationsFlowVerifiesCtrl.js
// module id = 383
// module chunks = 0